import { parsePhoneNumberFromString } from 'libphonenumber-js';

/**
 * Extracts the area code from a NANP (North American Numbering Plan) phone number
 * @param phoneNumber - The phone number to extract area code from
 * @returns The 3-digit area code or null if not extractable
 */
export const extractAreaCode = (phoneNumber: string): string | null => {
  if (!phoneNumber) {
    return null;
  }

  try {
    const parsed = parsePhoneNumberFromString(phoneNumber, 'US');

    if (!parsed || !parsed.isValid() || parsed.countryCallingCode !== '1') {
      return null;
    }

    const nationalNumber = parsed.nationalNumber;
    if (nationalNumber && nationalNumber.length === 10) {
      return nationalNumber.substring(0, 3);
    }

    return null;
  } catch {
    return null;
  }
};

/**
 * Resolves a 411 number using the caller's area code
 * Creates format: 1{areaCode}5551212
 * @param callerPhoneNumber - The caller's phone number to extract area code from
 * @returns The resolved 411 number or null if area code cannot be extracted
 */
export const resolve411Number = (callerPhoneNumber: string): string | null => {
  const areaCode = extractAreaCode(callerPhoneNumber);

  if (!areaCode) {
    return null;
  }

  return `1${areaCode}5551212`;
};
